<template>
  <div style="height: inherit">
    <router-view></router-view>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
export default {
  name: "Test",
  data() {
    return {};
  },
  methods: {
    start() {},
  },
  components: {
    Footer,
  },
};
</script>

<style scoped>
.body {
  background: white;
}
.icon {
  float: right;
  margin-right: 5%;
}
.title {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}
h1 {
  font-size: x-large;
}
.yellow {
  color: yellow;
}
.blue {
  color: blue;
}
img {
  width: 100%;
}
</style>